import React, { useState } from "react";
const MergeRequestTabTableSecondaryBrandValue: React.FC<{ brands: any }> = ({
  brands,
}) => {
  const [showMore, setShowMore] = useState(false);
  const brandsArray = brands.split("|||");
  if (!brands || brandsArray.length === 0) {
    return <span className="noDuplicates">No duplicates</span>;
  }
  const showList = showMore ? brandsArray : brandsArray.slice(0, 5);
  return (
    <div>
      <ul className="secondaryBrandList">
        {showList.map((brand: any) => (
          <li key={brand} className="secondaryBrandItem">
            {brand}
          </li>
        ))}
      </ul>
      {brandsArray.length > 5 && (
        <div
          className="showMore"
          onClick={(e) => {
            // e.stopPropagation();
            setShowMore(!showMore);
          }}
        >
          <div>{showMore ? "Show less" : `Show more...`}</div>
        </div>
      )}
    </div>
  );
};

export default MergeRequestTabTableSecondaryBrandValue;
